import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Gender } from '../models/gender.model';

@Injectable({
    providedIn: 'root'
})
export class GenderService {

    private apiURL: string;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/gender';

    }

    get(): any {

        const url = this.apiURL;
        return this.http.get<Gender[]>(url);

    }

}
